import http from "@/http";
import eventBus from "@/events";

const Route = {
    findAll: async function (ctx) {
        if(ctx) {
            const page = ctx.currentPage - 1 || 0;
            const size = ctx.perPage || 20;
            const sortDesc = ctx.sortDesc ? ',desc' : '';
            const sort = (ctx.sortBy || 'name') + sortDesc;
            const filter = ctx.filter ? ctx.filter : {};
            const pagination = {page, size, sort, sortDesc};
            const params = {...filter, ...pagination};
            const resp = await http("/routes/search/all", {params});
            eventBus.$emit('LIST_COUNT_ROUTE_EVENT', resp.data.page.totalElements);
            return resp.data._embedded.routes;
        } else {
            const resp = await http("/routes/search/all");
            eventBus.$emit('LIST_COUNT_ROUTE_EVENT', resp.data.page.totalElements);
            return resp.data._embedded.routes;
        }
    },
    create: function(data) {
        return http.post('/routes', data);
    },
    update: function (id, data) {
        return http.patch('/routes/' + id, data);
    },
    findById(id) {
        return http.get('/routes/' + id);
    },
    enable(id) {
        return http.patch('/routes/' + id + '/enable')
    },
    disable(id) {
        return http.patch('/routes/' + id + '/disable')
    },
    deleteById(id) {
        return http.delete('/routes/' + id)
    },
    findCompany: function(id) { return http.get('undefined'.replace('{id}', id)); },nameExists(name) {
        return http.get("/routes/exists/name", {params: {name: name}}).then(x => {
            return !x.data;
        });
    }
};

export default Route;
